import { Directive, ElementRef, AfterViewInit, Host, Input } from '@angular/core';
import { Utility } from './../../Common/Services/utility';
import { Router } from '@angular/router';

@Directive({
    selector: `[showUnSavedChangesAlert]`,
    host: {
        '(click)': 'onClick($event.target)'
    }
})
export class ShowUnSavedChangesAlertDirective implements AfterViewInit {
    @Input('showUnSavedChangesAlert') data: any;
    constructor(private elRef: ElementRef, private _utility: Utility, private _router: Router) {
    }
    ngAfterViewInit(): void {
        if (this.data.redirect) {
            this.elRef.nativeElement.style.cursor = 'pointer';
        }
    }

    onClick(btn) {
        if (this.data && this.data.form) {
            let form = this.data.form;
            let redirectTo = this.data.redirect;

            // As we have to pass array in router 
            if (typeof redirectTo == 'string') {
                redirectTo = [redirectTo];
            }
            if (!form.disabled && form.dirty) {
                this._utility.showUnsavedChangesConfirmBox(function () {
                    if (redirectTo)
                        this._router.navigate(redirectTo);

                }.bind(this));

            } else {
                if (redirectTo)
                    this._router.navigate(redirectTo);
            }
        }
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/show-unsavedchanges-alert.diretive.ts